import React, { forwardRef, memo } from "react";
import { Pressable, View } from "react-native";
import { Link } from "expo-router";

type TabProps = {
  value: string;
  children?: React.ReactNode;
  isActive?: boolean;
  isExpanded?: boolean;
  onPress?: () => void;
};

export const Tab = memo(
  forwardRef<View, TabProps>(
    ({ value, children, isActive, isExpanded, onPress }, ref) => {
      const borderStyle = isActive
        ? "border-b-2 border-primary"
        : isExpanded
          ? "border-b-2 border-primary-300"
          : "border-b-2 border-transparent";

      const pressableContent = (
        <Pressable
          ref={ref}
          onPress={onPress}
          className={`min-h-[48px] px-4 justify-center ${borderStyle}`}
        >
          {children}
        </Pressable>
      );

      if (onPress) {
        return pressableContent;
      }

      return (
        <Link href={value} asChild>
          {pressableContent}
        </Link>
      );
    },
  ),
);
